export class CText {
    text: string;
    color?: string;
    link?: string;

    constructor() {
        this.text = '';
        this.color = '#000000';
        this.link = '';
    }
}
